import * as React from "react";
import { connect } from 'react-redux';
import { fetchOrden, fetchDatosComprador } from '../../actions/ordenesActions';
import { fetchMotivosRevision } from "../../actions/publicacionesActions";
import { getLogoPlataformaById } from "../../helper/ordenHelper";
import { limpiarFiltros } from '../../actions/generalActios';
import DatosComprador from "./DatosComprador";
import BigSpinner from "../General/BigSpinner";
import Estados from "./Estados/EstadosOrden";
import MedioDePago from "./MedioDePago";
import Productos from "./Productos";
import Entrega from "./Entrega";
import Tab from '../General/Tab';


class OrdenEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            tabs: [
                { name: "Datos comprador", content: <DatosComprador idOrden={this.props.match.params.id} newOrden={false} /> },
                { name: "Productos", content: <Productos newOrden={false} /> },
                { name: "Entrega", content: <Entrega /> },
                { name: "Medio de pago", content: <MedioDePago newOrden={false} /> },
                { name: "Estados", content: <Estados history={this.props.history} /> }
            ]
        }
    }

    componentDidMount() {
        this.props.fetchOrden(this.props.match.params.id);
        this.props.fetchDatosComprador(this.props.match.params.id);
        this.props.fetchMotivosRevision();
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }

    return = () => {
        if (this.props.emptyFiltro.ordenes === false) {
            this.props.limpiarFiltros({
                publicaciones: true,
                ordenes: false,
                sellers: true,
                showFiltro: false,
                showFiltroOrdenes: true
            })
        }

        const pathReturn = this.props.location.state;
        this.props.history.push(`${pathReturn}`);
    }


    render() {
        let numeroOrden = this.props.match.params.id;
        let orden = JSON.stringify(this.props.orden);
        let idVendedorBoca = null;
        let imgLogo = null;

        if (orden != undefined) {
            if (orden != "{}") {
                idVendedorBoca = this.props.orden.idVendedorBoca;
                imgLogo =
                    <img
                        alt="icon_mega"
                        style={{ position: "absolute", top: "10px", right: "20px", width: "50px" }}
                        src={this.props.orden?.seller?.urlLogo != ""
                            ? this.props.orden.seller.urlLogo
                            : getLogoPlataformaById(this.props.orden.plataforma.codigo)
                        }
                    />
            }
        }


        return (
            <div className="col-sm-12">
                {this.props.loadingOrdenes ? <BigSpinner /> :
                    <div className="card">

                        {this.props.userType.isAdminMod && imgLogo}

                        {this.props.userType.isAdminMod &&
                            <label style={{ fontWeight: "bold", position: "absolute", top: "70px", right: "23px" }}>
                                {idVendedorBoca == 0 ? "" : idVendedorBoca}
                            </label>
                        }

                        <div className="card-body">
                            <h4 className="card-title">Orden - {numeroOrden}</h4>
                            <ul className="nav nav-tabs customtab" role="tablist">
                                {
                                    this.state.tabs.map((tab, index) => {
                                        return <div key={index} onClick={() => { this.onChangeActiveTab(index) }}>
                                            <Tab
                                                isActive={index == this.state.activeTab}
                                                name={tab.name}
                                                icon="ti-home"
                                            />
                                        </div>
                                    })
                                }
                            </ul>

                            <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                                {this.state.tabs[this.state.activeTab].content}
                                <div className="row align-items-center justify-content-center">
                                    <button
                                        onClick={this.return}
                                        className="col-auto btn btn-sm btn-light waves-effect waves-light"
                                    >
                                        Volver
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    orden: state.ordenes.orden,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar,
    userType: state.general.userType
});

export default connect(mapStateToProps, {
    fetchOrden,
    fetchDatosComprador,
    fetchMotivosRevision,
    limpiarFiltros
})(OrdenEdit);